import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const FlexMain = styled(Flex)`
  z-index: ${VIEWER_Z_INDEX.root};
  overflow: hidden;
  width: 100vw;
  height: var(--doc-height);

  background-color: ${theme.colors.zinc_50};
`;
